import React from 'react';
import Wrapper from './styles';
import UiBox from '../../../ui/box/UiBox';
import Snippet from '../../../snippet/Snippet';
import { translate } from '../../../../services/translate';
import Svg from '../../../svg/Svg';

interface Props {
    onClose: () => void;
}

export default function SportMatchOfTheDayCardRulesModal({ onClose }: Props) {
    return (
        <UiBox>
            <Wrapper>
                <div className="modal-header">
                    <span className="rules-modal-title">{translate('ui.account.terms---conditions')}</span>
                    <Svg icon="cross" size={0.8} className="pointer" onClick={onClose} />
                </div>
                <Snippet className="motd-rules" snippetKey="mod.rules" />
            </Wrapper>
        </UiBox>
    );
}
